import { STATIC_DATA_URL } from '../constants';

export const CONGRESS_DATA_URL = `${STATIC_DATA_URL}/congress`;
